import { computed } from 'vue';
import { useLocalStorage } from '@vueuse/core';
import { isEnabled } from '@monolith/legacy/services/features';

interface FeatureCriteria {
  startDate?: Date;
  endDate?: Date;
  featureFlag?: string;
}

const STORAGE_KEY = 'ak-highlight-display';

export function useHighlightDisplay(featureName: string, criteria: FeatureCriteria) {
  const highlightLocalStorage = useLocalStorage(STORAGE_KEY, '');

  const isStatusValid = computed(() => {
    const now = new Date();

    if (criteria.startDate && now < criteria.startDate) {
      return false;
    }

    if (criteria.endDate && now > criteria.endDate) {
      return false;
    }

    if (criteria.featureFlag && !isEnabled(criteria.featureFlag)) {
      return false;
    }

    if (getHighlightStatus(featureName)) {
      return false;
    }

    return true;
  });

  function getHighlightStatus(featureName: string) {
    const features = highlightLocalStorage.value.split(',').filter(Boolean);
    return features.includes(featureName);
  }

  function setHighlightStatus(featureName: string) {
    const features = highlightLocalStorage.value.split(',').filter(Boolean);

    if (!features.includes(featureName)) {
      features.push(featureName);
      highlightLocalStorage.value = features.join(',');
    }
  }

  function removeHighlightStatus(featureName: string) {
    const features = highlightLocalStorage.value.split(',').filter(Boolean);
    highlightLocalStorage.value = features.filter((feature) => feature !== featureName).join(',');
  }

  function deleteHighlightStatus() {
    highlightLocalStorage.value = '';
  }

  return {
    highlightLocalStorage,
    isStatusValid,
    deleteHighlightStatus,
    removeHighlightStatus,
    setHighlightStatus,
  };
}
